import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'app/shared/shared.module';
import { SharedPosGraduacaoModule } from '../../shared/shared-pos-graduacao.module';
import { DetalheCursoComponent } from './detalhe-curso.component';
import { SobreOProgramaComponent } from './sobre-o-programa/sobre-o-programa.component';
import { DetalheCursoRouter } from './detalhe-curso.router';

@NgModule({
    imports: [
      CommonModule,
      SharedModule,
      DetalheCursoRouter,
      SharedPosGraduacaoModule
    ],
    declarations: [
      DetalheCursoComponent,
      SobreOProgramaComponent
    ]
  })
  export class DetalheCursoModule { }